import { Button } from '@at/design-system-elements'
import styled from 'styled-components'
import { ThemeSelectors, TypeBeetle, TypeFiesta } from '@at/design-system-foundation'

export const StyledResetToLowestMonthlyPriceButton = styled(Button)`
    padding: 0;
`

export const StyledTermsTitleText = styled(TypeBeetle)`
    padding-top: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)};
    font-variation-settings: 'wght' 500;
`

export const StyledTermsText = styled(TypeFiesta)`
    padding-bottom: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
`

export const StyledBoldTermsText = styled(TypeFiesta).attrs({ as: 'span' })`
    font-variation-settings: 'wght' 500;
`
